import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';
import { StackedCarousel } from 'react-stacked-center-carousel';
import _Card from './components/Card';

export const PeopleBackground = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.turquoise};
  padding-bottom: 100px;
`;

export const PeopleContainer = styled.div`
  max-width: 1340px;
  margin: 0 auto;
`;

export const PeopleHeader = styled.div`
  max-width: 1340px;
  padding: 0 20px;
  margin: 0 auto;
  width: 100%;
  margin-bottom: 50px;

  @media ${sizes.tabletLandscape} {
    padding: 0px 40px;
  }
`;

export const StyledCarousel = styled(StackedCarousel)`
  @media ${sizes.largeDesktop} {
    min-height: 494px;
  }

  > div {
    overflow: hidden;
    border-radius: 24px;
  }
`;

export const Title = styled.h1`
  font-weight: 700;
  font-size: 24px;
  line-height: 40px;
  color: ${th('colors.black')};
  letter-spacing: 0;
  margin-bottom: 8px;

  @media ${sizes.tabletLandscape} {
    font-size: 32px;
    margin-bottom: 10px;
    line-height: 44px;
  }
`;

export const Link = styled.a`
  color: ${th('colors.black')};
  line-height: 24px;
  text-decoration: none;

  :hover {
    text-decoration: underline;
  }
`;

export const Card = styled(_Card)``;

export const Cards = styled.div`
  max-width: 1150px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 6%;
  width: 100%;

  @media ${sizes.desktop} {
    padding: 0 55px 0 50px;
  }
`;

export const CardsMobileWrapper = styled.div`
  overflow: hidden;
`;
